<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CaretAnchoredPicker from 'dashboard/components-next/preview-picker/CaretAnchoredPicker.vue';

defineProps({
  caretPosition: { type: Object, default: null },
  items: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['select', 'close', 'removeTrigger']);
const search = defineModel('search', { type: String, default: '' });
const { t } = useI18n();

const emptyLabel = computed(() =>
  search.value.trim()
    ? t('INTERNAL_CHAT.MENTION_EMPTY')
    : t('INTERNAL_CHAT.MENTION_TYPE_TO_SEARCH')
);

const iconByType = {
  contact: 'i-lucide-contact',
  kanban_item: 'i-lucide-kanban',
  conversation: 'i-lucide-messages-square',
};
</script>

<template>
  <CaretAnchoredPicker
    v-model:search="search"
    :caret-position="caretPosition"
    :items="items"
    :search-placeholder="t('INTERNAL_CHAT.MENTION_SEARCH')"
    :empty-label="emptyLabel"
    :is-loading="isLoading"
    @select="item => emit('select', item)"
    @close="emit('close')"
    @remove-trigger="emit('removeTrigger')"
  >
    <template #leading="{ item }">
      <span
        class="inline-flex items-center justify-center flex-shrink-0 size-6 rounded-full bg-n-alpha-2 text-n-slate-10"
        aria-hidden="true"
      >
        <i :class="[iconByType[item.record.type], 'size-3.5']" />
      </span>
    </template>
  </CaretAnchoredPicker>
</template>
